var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.707 14.7071C14.3164 15.0976 13.6833 15.0976 13.2927 14.7071L9.99985 11.4142L6.70695 14.7071C6.31643 15.0976 5.68327 15.0976 5.29274 14.7071C4.90222 14.3166 4.90222 13.6834 5.29274 13.2929L8.58563 10L5.29274 6.70711C4.90222 6.31658 4.90222 5.68342 5.29274 5.29289C5.68327 4.90237 6.31643 4.90237 6.70695 5.29289L9.99985 8.58579L13.2927 5.29289C13.6833 4.90237 14.3164 4.90237 14.707 5.29289C15.0975 5.68342 15.0975 6.31658 14.707 6.70711L11.4141 10L14.707 13.2929C15.0975 13.6834 15.0975 14.3166 14.707 14.7071Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/Close.660362172b772c7a6d1e38009b3addce.svg";
export { ForwardRef as ReactComponent };